import { writable } from "svelte/store";

export const showAlert = writable({message: "", color: "black"});
